<template>
    <el-dialog
            :title="'详情'"
            :close-on-click-modal="false"
            :visible.sync="visible"
            style="text-align: left">
        <el-form :model="dataForm"  ref="dataForm"
                 label-width="150px">
            <el-row>
                <el-col :span="12">
                    <el-form-item label="职员工号" prop="zygh">
                        <div class="min-input-class">{{dataForm.zygh}}</div>
                    </el-form-item>
                </el-col>
                <el-col :span="12">  
                    <el-form-item label="职员姓名" prop="zyxm">
                        <div class="min-input-class">{{dataForm.zyxm}}</div>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12"> 
                    <el-form-item label="独生子女" prop="dszn">
                        <div class="min-input-class">{{dataForm.dszn}}</div>
                    </el-form-item>
                </el-col>
                <el-col :span="12">  
                    <el-form-item label="车贴" prop="ct">
                        <div class="min-input-class">{{dataForm.ct}}</div>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
        <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
    </span>
    </el-dialog>
</template>

<script>
    export default {

        data () {
            return {

                visible: false,
                menuList: [],
                customerList:[],
                dataForm: {
                    id: '',
                    zygh: '',
                    zyxm: '',
                    dszn: '',
                    ct: ''
                }
            }
        },
        methods: {
            init (id) {
                this.dataForm.id = id
                this.visible = true
                this.$nextTick
                (() => {
                    this.$refs['dataForm'].resetFields()
                    if(this.dataForm.id) {
                        this.$http
                        ({
                            url: '/bjba/salary/template/info/'+this.dataForm.id,
                            method: 'get'
                        }).then(({data}) => {
                            this.dataForm.id    = data.data.id
                            this.dataForm.zygh    = data.data.zygh
                            this.dataForm.zyxm    = data.data.zyxm
                            this.dataForm.dszn    = data.data.dszn
                            this.dataForm.ct    = data.data.ct
                        })
                    }
                })

            }
        }
    }
</script>
<style lang="scss" scoped>
    .min-input-class {

        min-height:25px;
        border-bottom:1px dotted  #b0b1b3;
    }
</style>
